import { useTranslation } from 'react-i18next';
import type { ParamSpec, ParamValue } from '../types.js';
import { SegmentedField } from './fields/SegmentedField.js';
import { SliderField } from './fields/SliderField.js';
import { ChipsField } from './fields/ChipsField.js';

interface Props {
  schema: ParamSpec[];
  values: Record<string, ParamValue>;
  onChange: (key: string, value: ParamValue) => void;
  disabled?: boolean;
}

export function ParamControls({ schema, values, onChange, disabled }: Props) {
  const { t } = useTranslation('originals');
  if (schema.length === 0) return null;
  return (
    <div className="flex flex-col gap-3">
      {schema.map((spec) => {
        const value = values[spec.key] ?? spec.default;
        const label = t(spec.labelKey);
        if (spec.kind === 'slider') {
          return (
            <SliderField
              key={spec.key}
              label={label}
              value={Number(value)}
              min={spec.min ?? 0}
              max={spec.max ?? 100}
              step={spec.step ?? 1}
              disabled={disabled}
              onChange={(v) => onChange(spec.key, v)}
            />
          );
        }
        const options = (spec.options ?? []).map((o) => ({ value: o.value, label: t(o.labelKey) }));
        const Field = spec.kind === 'chips' ? ChipsField : SegmentedField;
        return (
          <Field
            key={spec.key}
            label={label}
            value={value}
            options={options}
            disabled={disabled}
            onChange={(v) => onChange(spec.key, v)}
          />
        );
      })}
    </div>
  );
}
